import { render, staticRenderFns } from "./StaffWashRequestList.vue?vue&type=template&id=f763ed4c"
import script from "./StaffWashRequestList.vue?vue&type=script&lang=js"
export * from "./StaffWashRequestList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports